import { useState } from 'react';
import { paquetesApi } from '@/lib/api/paquetes.js';

export function FotoUploader({
  onChange,
  max = 5,
}: {
  onChange: (keys: string[]) => void;
  max?: number;
}) {
  const [keys, setKeys] = useState<string[]>([]);
  const [busy, setBusy] = useState(false);

  async function handleFile(file: File) {
    if (keys.length >= max) return;
    setBusy(true);
    try {
      const { uploadUrl, fotoKey } = await paquetesApi.fotoUploadUrl({
        contentType: file.type as 'image/jpeg' | 'image/png' | 'image/webp',
        contentLength: file.size,
      });
      await fetch(uploadUrl, { method: 'PUT', body: file, headers: { 'content-type': file.type } });
      const next = [...keys, fotoKey];
      setKeys(next);
      onChange(next);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex gap-2 flex-wrap">
      {keys.map((k) => (
        <div key={k} className="w-20 h-20 bg-gray-200 rounded" />
      ))}
      {keys.length < max && (
        <label className="w-20 h-20 border-2 border-dashed rounded flex items-center justify-center cursor-pointer">
          <input
            type="file"
            accept="image/jpeg,image/png,image/webp"
            className="hidden"
            onChange={(e) => e.target.files?.[0] && handleFile(e.target.files[0])}
            disabled={busy}
          />
          +
        </label>
      )}
    </div>
  );
}
